import { Content } from 'src/contexts/ContentContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { ContentId } from 'src/utils/constants/contentId';

export const LaunchSplitSelectedListings = ({
  onClick,
  disabled,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}) => {
  return (
    <PosDropdownItem
      key="BulkSplitSelectedListings"
      onClick={onClick}
      disabled={disabled}
    >
      <Content id={ContentId.SplitSelected} />
    </PosDropdownItem>
  );
};
